import { useRef } from 'react';

/**
 * True while a scope change (header/modal filters) is refetching behind the
 * previous data kept by `keepPreviousData`. Search keystrokes also refetch but
 * must not blank the table, so they are excluded.
 */
export const useScopeRefreshing = (
  isRefreshing: boolean,
  search: string
): boolean => {
  const settledSearch = useRef(search);
  if (!isRefreshing) settledSearch.current = search;
  return isRefreshing && settledSearch.current === search;
};
